/* eslint-disable fsecond/valid-event-listener, @typescript-eslint/no-unnecessary-type-conversion */
import { useEffect, useState } from 'react'

const MOBILE_BREAKPOINT = 768

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(
    // eslint-disable-next-line arrow-return-style/arrow-return-style
    () =>
      // eslint-disable-next-line no-negated-condition
      typeof window !== 'undefined'
        ? window.innerWidth < MOBILE_BREAKPOINT
        : false,
  )

  useEffect(() => {
    const mql = globalThis.matchMedia(
      `(max-width: ${String(MOBILE_BREAKPOINT - 1)}px)`,
    )
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }

    mql.addEventListener('change', onChange)

    return () => {
      mql.removeEventListener('change', onChange)
    }
  }, [])

  return Boolean(isMobile)
}
